<template>
    <div class="sitesetting">
        <el-form ref="form" label-width="150px" label-position="left" class="site-content" v-if="currentSite">
            <el-form-item label="站点名称">
                <el-input v-model="currentSite.sitename" disabled></el-input>
            </el-form-item>
            <el-form-item label="是否启用金额报警">
                <el-switch v-model="currentSite.amount_alarm"></el-switch>
            </el-form-item>
            <el-form-item label="最低金额">
                <el-input size="small" @input="e=>handleEdit(e,'min_amount')" v-model="currentSite.min_amount" class="customize"></el-input>
            </el-form-item>
            <el-form-item label="金额报警间隔">
                <el-input-number v-model="currentSite.amount_interval" :min="0.5" :step="0.5" label="金额报警间隔"></el-input-number>
            </el-form-item>

           <el-form-item label="是否启用通讯报警">
                <el-switch v-model="currentSite.communication_alarm"></el-switch>
            </el-form-item>
            <el-form-item label="通讯报警间隔">
                <el-input-number v-model="currentSite.communication_interval" :min="0.5" :step="0.5" label="通讯报警间隔"></el-input-number>
            </el-form-item>

            <el-form-item label="是否启用费用充值">
                <el-switch v-model="currentSite.enable_billing"></el-switch>
            </el-form-item>

        </el-form>

        <div class="btn-array">
            <el-button type="primary" size="small" @click="saveData">保存</el-button>
        </div>
    </div>
</template>

<script>
import {updateSiteConfig} from "@api/siteconfig";
/**
 * 设备开关
 */
export default {
    name:"sitesetting",
    props:["site"],
    data(){
        return {
           currentSite:null,
        }
    },
    watch:{
        site(){
            this.currentSite=JSON.parse(JSON.stringify(this.site));
        }
    },
    mounted(){
       this.currentSite=JSON.parse(JSON.stringify(this.site));
    },
    methods:{
        // 保存数据
        saveData(){
            updateSiteConfig(this.currentSite).then(res=>{
                if(res.status&&res.status==200){
                    this.$message({
                        message:"数据更新成功",
                        type:"success"
                    });
                    // 刷新数据列表
                    this.$bus.$emit("updateSiteConfigRecord");
                }
            })
        },
        // 输入框格式化
        handleEdit(e,type) {
            let value = e.replace(/[^\-\d.]/g, '') // 只能输入.和-和数字
            value = value.replace(/^\./g, '')  //第一个字符不能是.
            value = value.replace(/\.{2,}/g, '.') // 不能连续输入.
            value = value.replace(/(\.\d+)\./g, '$1') // .后面不能再输入.
            value = value.replace(/(-)\./g, '$1') // -后面不能输入.
            value = value.replace(/\-{2,}/g, '-') // -只能保留一个
            value = value.replace(/(\d+|\.)-/g, '$1') // 数字和.后面不能接-,不能出现类似11-, 12.-
            value = value.replace(/-(0){2,}/g, "$1") // 不能出现-00,-001,-0001类似
            value = value.replace(/(-)0+(\d+)/g, '$1$2') // 不能出现-01,-02类似
            value = value.replace(/^0+(\d)/, '$1') // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
            value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
            this.$set(this.currentSite,type,value)
        }
    }
}
</script>

<style lang="scss" scoped>
/** 站点设置 */
.sitesetting{
    min-width: 300px;
    min-height: 300px;

    .relayform-content{
        padding:0 50px;

        .site-list{
            width: 180px;
        }

        ::v-deep .el-form-item{
            button{
                margin-left: 10px;
            }
        }

    }

    .form-right{
        margin-left: 10px;
    }

    .btn-array{
        text-align: center;
    }

}
</style>